import moment from 'moment-timezone';
import { get } from 'lodash';
import { Icon } from 'components/common';
import { TRANSACTION_LABEL, TRANSACTION_STATUS_COLOR, TRANSACTION_STATUS_ICON, TRANSACTION_STATUS_NAME } from './transaction';
import { getDateTime } from './date-time';

export const formatLogoutTransactionsSummary = (data = []) =>
  data.map(item => {
    const amount = get(item, 'transAmount', '');
    const status = get(item, 'transStatus', '');
    const category = get(item, 'transCategory', '');
    const type = get(item, 'transType', '');
    const fromAccount = get(item, 'fromAccount', '');
    const transDate = get(item, 'transDate', '');

    const categoryLabel = TRANSACTION_LABEL.get(category);
    const categoryColor = TRANSACTION_STATUS_COLOR(status);
    const categoryIcon = TRANSACTION_STATUS_ICON(status);
    const newStatusTwoLanguage = TRANSACTION_STATUS_NAME(status);

    const date = getDateTime(transDate, true);

    const newAmount = <span className={amount.includes('-') ? 'red' : 'green'}>{amount}</span>;
    const newStatus = (
      <span className={categoryColor}>
        <Icon type={categoryIcon} fontSize="small" />
        &nbsp;
        {newStatusTwoLanguage}
      </span>
    );
    const newActivityDetail = (
      <span>
        {categoryLabel}
        &nbsp;-&nbsp;
        {type}
        <br />
        {fromAccount}
      </span>
    );

    return {
      ...item,
      transStatus: newStatus,
      transAmount: newAmount,
      transType: newActivityDetail,
      transDate: `${moment(date).format('DD/MM/YYYY HH:mm')}`,
    };
  });

export const parseTimeWithInformation = string => (string.includes('at') ? string.slice(14, 23) : string.slice(15, 23));
